import { styled as muiStyled } from '@mui/material/styles';
import { dark } from "styles/theme";
import { Box, Tabs } from "@mui/material";


export const TabStyles = muiStyled(Tabs)(({ theme }) => ({
    '.MuiButtonBase-root.MuiTab-root': {
        minWidth: 50,
        borderBottom: `6px solid transparent`
    },
    '& .Mui-selected': {
        color: `${dark} !important`,
        fontWeight: "bold",
        borderBottom: `6px solid ${dark} !important`
    },
}))


export const CustomBadgeStyles = muiStyled(Box)(({ theme }) => ({
    width: 20,
    height: 20,
    borderRadius: 35,
    // background:
}))
 export const IconTabStyles = muiStyled(Tabs)(({ theme }) => ({
    minHeight: 44,
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: '4px',
    border: '1px solid #e0e6ef',

    '& .MuiTabs-indicator': {
        display: 'none', // מסתיר את הקו התחתון
    },

    '.MuiButtonBase-root.MuiTab-root': {
        minWidth: 44,
        minHeight: 36,
        borderRadius: 8,
        padding: '6px 10px',
        transition: 'background 0.2s',
    },

    '& .Mui-selected': {
        backgroundColor: '#e8eef7',
        color: `${dark} !important`,
        fontWeight: 'bold',
    },
}))